import React from 'react'
import type { KambiHistoryCoupon } from '@mobi/api-types/kambi'
import { SameGameMulti } from '@core/Areas/KambiSports/Player/Components/Coupon/Components/BetInfo/Components/SameGameMulti'
import { Multi } from '@core/Areas/KambiSports/Player/Components/Coupon/Components/BetInfo/Components/Multi'
import { getKambiCouponBetType } from '@core/Areas/KambiSports/Player/helpers/getKambiCouponBetType'

export const SelectionInfo: React.FC<{ historyCoupon: KambiHistoryCoupon }> = ({
  historyCoupon,
}) => {
  const betType = getKambiCouponBetType(historyCoupon)

  if (betType === 'multi') return <Multi historyCoupon={historyCoupon} />

  if (betType === 'same-game-multi') {
    const { events, bets, betOffers, outcomes } = historyCoupon
    const oddsPlayed = bets[0].betOddsBoosted ?? bets[0].playedOdds

    return (
      <SameGameMulti
        legCount={outcomes.length}
        event={events[0]}
        outcomes={outcomes}
        betOffers={betOffers}
        betStatus={bets[0].betStatus}
        playedOdds={oddsPlayed}
      />
    )
  }
  return null
}
